<script>
  import AdGroupDetail from './AdGroupDetail.vue'
  import AdGroupBannerDialog from './AdGroupBannerDialog.vue'
  import { AdGroupSimpleEditor } from './groupBanner'
  import { getAdGroupPage } from '@/api/marketing/adGroup'
  import { getAdGroupStatusMap } from '../config/format'
  import {
    adGroupUpdate,
    changeAdGroupStatus,
    getAdGroupDetailInfo
  } from '../../../../api/marketing/adGroup'
  import { getPageEnumList } from '@/api/marketing/advertising'
  import RejectDialog from './RejectDialog.vue'

  export default {
    name: 'AdGroupList',
    components: {
      AdGroupDetail,
      AdGroupBannerDialog,
      AdGroupSimpleEditor,
      RejectDialog
    },
    data() {
      return {
        loading: false,
        searchFormItems: [
          {
            type: 'input',
            label: '广告组名称',
            prop: 'name'
          },
          {
            type: 'daterange',
            label: '创建时间',
            prop: 'time'
          },
          {
            type: 'input',
            label: '创建人',
            prop: 'createUser'
          },
          {
            type: 'select',
            label: '状态',
            prop: 'state',
            options: getAdGroupStatusMap({}, true)
          },
          {
            type: 'select',
            label: '展示页面',
            prop: 'displayPage',
            options: []
          }
        ],
        initVals: {
          name: '',
          createTime: '',
          createUserName: '',
          state: ''
        },
        query: {},
        tableData: [],
        pagination: {
          total: 0,
          current: 1,
          pageSize: 10
        },
        detailVisible: false,
        currentAdGroup: null,
        bannerDialogVisible: false,
        simpleEditorVisible: false,
        mode: 'config',
        rejectDialogVisible: false
      }
    },
    created() {
      let adGroupParams = sessionStorage.getItem('adGroupParams')
      if (adGroupParams) {
        adGroupParams = JSON.parse(adGroupParams)
        this.query = { ...adGroupParams }
      }
      getPageEnumList().then((res) => {
        const { code, data } = res
        if (code === 0) {
          this.$set(this.searchFormItems, 4, {
            ...this.searchFormItems[4],
            options: data.bannerDisplayPage || []
          })
        }
      })
    },
    computed: {
      btnBold() {
        return (prop, row) => {
          // 草稿 =》 0 | 待审核 =》 1 | 审核不通过 =》 2 | 已启用 =》 3 | 已隐藏 =》 4
          const map = new Map([
            ['edit', new Set([0, 1, 2, 3, 4])],
            ['submitAudit', new Set([0])],
            ['delete', new Set([0])],
            ['pass', new Set([1])],
            ['noPass', new Set([1])],
            ['configBanner', new Set([3, 4])],
            ['hide', new Set([3])],
            ['enable', new Set([4])]
          ])
          const set = map.get(prop) || new Set()
          return set.has(row.state)
        }
      }
    },
    methods: {
      // 获取列表数据
      async getList() {
        this.loading = true
        try {
          const { time, ...rest } = this.query
          const params = {
            ...rest,
            current: this.pagination.current,
            size: this.pagination.pageSize
          }
          if (time) {
            params.startTime = time[0]
            params.endTime = time[1]
          }
          const res = await getAdGroupPage(params)
          if (res.data) {
            this.tableData = res.data.records || []
            this.pagination.total = res.data.total || 0
          }
        } catch (error) {
          this.$message.error('获取广告组列表失败')
          console.error('获取广告组列表失败:', error)
        } finally {
          this.loading = false
        }
      },
      // 搜索
      handleSearch(form) {
        Object.assign(this.query, form)
        this.pagination.current = 1
        this.getList()
      },
      // 重置搜索
      handleReset(form) {
        Object.assign(this.query, form)
        this.pagination.current = 1
        this.getList()
      },
      // 处理表格分页变化
      onTableChange({ current, pageSize }) {
        this.pagination.pageSize = pageSize
        this.pagination.current = current
        this.getList()
      },
      // 新增广告组
      addAdGroup() {
        this.$router.push('/adgroup/create')
      },
      // 编辑广告组
      editAdGroup(row) {
        const set = new Set([0, 1, 2])
        if (set.has(row.state)) {
          // 进行整体修改
          this.$router.push(`/adgroup/edit/${row.id}`)
        } else {
          // 部分修改
          getAdGroupDetailInfo(row.id).then((res) => {
            const { code, data } = res
            if (code === 0) {
              const set = new Set()
              data.bannerList = data.bannerList.filter((banner) => {
                if (banner.defId && !set.has(banner.templateSloKey)) {
                  set.add(banner.templateSloKey)
                  return true
                }
                return false
              })
              console.log('data', data)
              this.currentAdGroup = data
              // 已启用或已隐藏状态下，打开简化版编辑弹窗
              // this.currentAdGroup = row
              this.simpleEditorVisible = true
            }
          })
        }
      },
      // 设置广告组状态
      setAdGroupStatus(state, row) {
        const stateMap = {
          3: '通过后广告组包含的banner 位均视为审核通过，将在乘客端展示，是否确认通过?',
          // 4: '确定申核不通过吗?拒绝后广告组包含的 banner均视为拒绝',
          2: '是否确认删除?确认后删除已保存的草稿数据',
          5: '操作隐藏后，当前广告组在乘客端不再展示'
        }
        const stateMap1 = {
          1: '提交审核',
          2: '删除',
          3: '审核',
          4: '审核',
          6: '启用',
          5: '隐藏'
        }
        const httpFunc = () => {
          changeAdGroupStatus({
            adGroupId: row.id,
            operateStatus: state
          }).then((res) => {
            const { code } = res
            if (code === 0) {
              this.$message.success(`${stateMap1[state]}成功`)
              this.bannerDialogVisible = false
              this.getList()
            }
          })
        }
        if (stateMap[state]) {
          this.$confirm(`${stateMap[state]}`, '提示', {
            confirmButtonText: '确定',
            cancelButtonText: '取消',
            type: 'warning'
          }).then(() => {
            if (state === 4) {
              this.currentAdGroup = row
              this.rejectDialogVisible = true
            } else {
              httpFunc()
            }
          })
        } else {
          if (state === 4) {
            this.currentAdGroup = row
            this.rejectDialogVisible = true
          } else {
            httpFunc()
          }
        }
      },
      // 打开配置banner弹窗
      openBannerDialog(row, mark) {
        this.mode = mark
        this.currentAdGroup = row
        this.bannerDialogVisible = true
      },
      // 处理简化版编辑弹窗的关闭
      handleSimpleEditorClose() {
        this.simpleEditorVisible = false
      },
      // 处理简化版编辑弹窗的保存
      handleSimpleEditorSave() {
        if (this.$refs.simpleEditor) {
          this.$refs.simpleEditor
            .validate()
            .then((formData) => {
              // 在实际项目中调用API保存数据
              console.log('保存广告组数据:', formData)
              const { id, name, allPositionsData, weights } = formData
              const updateBanners = Object.keys(allPositionsData).map((item) => {
                const { defAdId, slotKey } = allPositionsData[item]
                return {
                  defAdId,
                  templateSloKey: slotKey
                }
              })
              adGroupUpdate({
                id,
                name,
                weights,
                updateBanners
              }).then((res) => {
                const { code } = res
                if (code === 0) {
                  this.$message.success('保存成功')
                  this.simpleEditorVisible = false
                  // 刷新列表
                  this.getList()
                }
              })
            })
            .catch((error) => {
              this.$message.error(error.message || '表单验证失败')
            })
        }
      },
      // 打开广告组详情抽屉
      openAdGroupDetail(row) {
        this.currentAdGroup = row
        this.detailVisible = true
      },

      handleRejectConfirm(data) {
        changeAdGroupStatus({
          adGroupId: data.id,
          operateStatus: 4,
          refuseReason: data.reason
        }).then((res) => {
          const { code } = res
          if (code === 0) {
            this.$message.success('审核成功')
            this.rejectDialogVisible = false
            this.getList()
          }
        })
      }
    }
  }
</script>

<template>
  <div class="ad-group-list-container">
    <!-- 搜索栏 -->
    <YDSearchForm
      :form-items="searchFormItems"
      :initial-values="initVals"
      @search="handleSearch"
      @reset="handleReset"
      @add="addAdGroup"
      permi="user_advertising_edit"
      :use-cache="true"
      :cache-options="{
        type: 'session',
        key: 'adGroupParams'
      }"
    >
      <template #createTimeSlot="{ formData }">
        <el-date-picker
          v-model="formData.createTime"
          type="date"
          placeholder="选择日期"
          value-format="yyyy-MM-dd"
          style="width: 100%"
        />
      </template>
    </YDSearchForm>

    <!-- 广告组列表 -->
    <yd-table
      ref="adGroupTable"
      :data="tableData"
      :pagination="pagination"
      :loading="loading"
      @onChange="onTableChange"
    >
      <el-table-column prop="id" label="ID" width="80" align="center" />
      <el-table-column prop="name" label="广告组名称" align="center">
        <template slot-scope="scope">
          <el-link type="primary" @click="openAdGroupDetail(scope.row)">{{
            scope.row.name
          }}</el-link>
        </template>
      </el-table-column>
      <el-table-column prop="weights" label="权重" width="80" align="center" />
      <el-table-column prop="bannerDisplayPage" label="展示页面" width="120" align="center" />
      <el-table-column label="状态" width="120" align="center">
        <template slot-scope="scope">
          <span :class="['status-text', `status-${scope.row.state}`]">
            {{ scope.row.stateStr }}
          </span>
        </template>
      </el-table-column>
      <el-table-column prop="createUserName" label="创建人" align="center" />
      <el-table-column prop="createTime" label="创建时间" width="180" align="center" />
      <el-table-column label="操作" width="280" align="center">
        <template slot-scope="scope">
          <div class="operation-buttons">
            <!--            v-has-permi="['user_advertising_edit']"-->
            <el-button
              type="text"
              size="mini"
              @click="editAdGroup(scope.row)"
              v-if="btnBold('edit', scope.row)"
              v-has-permi="['user_advertising_edit']"
              >编辑</el-button
            >
            <!--            v-has-permi="['user_advertising_submitAudit']"-->
            <el-button
              type="text"
              size="mini"
              @click="setAdGroupStatus(1, scope.row)"
              v-if="btnBold('submitAudit', scope.row)"
              v-has-permi="['user_advertising_submitAudit']"
              >提交审核</el-button
            >
            <!--            v-has-permi="['user_advertising_review']"-->
            <el-button
              type="text"
              size="mini"
              @click="setAdGroupStatus(3, scope.row)"
              v-if="btnBold('pass', scope.row)"
              v-has-permi="['user_advertising_review']"
              >通过</el-button
            >
            <!--            v-has-permi="['user_advertising_review']"-->
            <el-button
              type="text"
              size="mini"
              class="danger-button"
              v-if="btnBold('noPass', scope.row)"
              @click="setAdGroupStatus(4, scope.row)"
              v-has-permi="['user_advertising_review']"
              >不通过</el-button
            >
            <!--            v-has-permi="['user_advertising_configBanner']"-->
            <el-button
              type="text"
              size="mini"
              class="primary-button"
              @click="openBannerDialog(scope.row, 'config')"
              v-if="btnBold('configBanner', scope.row)"
              v-has-permi="['user_advertising_configBanner']"
              >配置banner</el-button
            >
            <!--            v-has-permi="['user_advertising_hide']"-->
            <el-button
              type="text"
              size="mini"
              class="orange-button"
              @click="setAdGroupStatus(5, scope.row)"
              v-if="btnBold('hide', scope.row)"
              v-has-permi="['user_advertising_hide']"
              >隐藏</el-button
            >
            <!--            v-has-permi="['user_advertising_enable']"-->
            <el-button
              type="text"
              size="mini"
              class="green-button"
              @click="openBannerDialog(scope.row, 'enable')"
              v-if="btnBold('enable', scope.row)"
              v-has-permi="['user_advertising_enable']"
              >启用</el-button
            >
            <!--            v-has-permi="['user_advertising_delete']"-->
            <el-button
              type="text"
              size="mini"
              class="danger-button"
              @click="setAdGroupStatus(2, scope.row)"
              v-if="btnBold('delete', scope.row)"
              v-has-permi="['user_advertising_delete']"
              >删除</el-button
            >
          </div>
        </template>
      </el-table-column>
    </yd-table>

    <!-- 广告组详情 -->
    <AdGroupDetail
      :visible.sync="detailVisible"
      :adGroupId="currentAdGroup ? currentAdGroup.id : ''"
    />

    <!-- 广告组Banner配置弹窗 -->
    <AdGroupBannerDialog
      :visible.sync="bannerDialogVisible"
      :adGroupId="currentAdGroup ? currentAdGroup.id : ''"
      :adGroupName="currentAdGroup ? currentAdGroup.name : ''"
      :templateId="currentAdGroup ? currentAdGroup.templateId : ''"
      :displayPageName="currentAdGroup ? currentAdGroup.bannerDisplayPage : ''"
      :mode="mode"
      @confirm="setAdGroupStatus(6, currentAdGroup)"
      v-if="bannerDialogVisible"
    />

    <!-- 简化版广告组编辑弹窗 -->
    <el-dialog
      :title="
        currentAdGroup
          ? `编辑广告组: ${currentAdGroup.adGroup ? currentAdGroup.adGroup.name : ''}`
          : '编辑广告组'
      "
      :visible.sync="simpleEditorVisible"
      width="900px"
      :before-close="handleSimpleEditorClose"
      append-to-body
    >
      <AdGroupSimpleEditor
        ref="simpleEditor"
        v-if="simpleEditorVisible && currentAdGroup"
        :currentAdGroup="currentAdGroup"
        :is-edit="true"
      />
      <div slot="footer" class="dialog-footer">
        <el-button @click="handleSimpleEditorClose">取消</el-button>
        <el-button type="primary" @click="handleSimpleEditorSave">保存</el-button>
      </div>
    </el-dialog>
    <RejectDialog
      :visible.sync="rejectDialogVisible"
      :bannerId="currentAdGroup ? currentAdGroup.id : ''"
      @confirm="handleRejectConfirm"
      type="adGroup"
    />
  </div>
</template>

<style scoped lang="scss">
  .ad-group-list-container {
    .danger-button {
      color: #f56c6c;
    }

    .green-button {
      color: #67c23a;
    }

    .orange-button {
      color: #e6a23c;
    }

    .primary-button {
      color: #409eff;
    }

    .status-text {
      display: inline-block;
      padding: 0 10px;
      height: 24px;
      line-height: 22px;
      font-size: 12px;
      border-radius: 12px;
      box-sizing: border-box;
      white-space: nowrap;

      &.status-0 {
        color: #909399;
        background-color: rgba(144, 147, 153, 0.1);
        border: 1px solid rgba(144, 147, 153, 0.2);
      }

      &.status-1 {
        color: #e6a23c;
        background-color: rgba(230, 162, 60, 0.1);
        border: 1px solid rgba(230, 162, 60, 0.2);
      }

      &.status-2 {
        color: #f56c6c;
        background-color: rgba(245, 108, 108, 0.1);
        border: 1px solid rgba(245, 108, 108, 0.2);
      }

      &.status-3 {
        color: #67c23a;
        background-color: rgba(103, 194, 58, 0.1);
        border: 1px solid rgba(103, 194, 58, 0.2);
      }

      &.status-4 {
        color: #909399;
        background-color: rgba(144, 147, 153, 0.1);
        border: 1px solid rgba(144, 147, 153, 0.2);
      }
    }

    .operation-buttons {
      .el-button {
        padding: 4px 8px;
        margin-left: 0;
        margin-right: 8px;

        &:last-child {
          margin-right: 0;
        }
      }
    }
  }
</style>
